import gql from 'graphql-tag';
import { CREDIT_SUBMISSION_DECISION_FRAGMENT } from './fragments';

export const CREATE_CREDIT_SUBMISSION_DECISION = gql`
  ${CREDIT_SUBMISSION_DECISION_FRAGMENT}
  mutation CreateCreditSubmissionDecision($input: CreateCreditSubmissionDecisionInput!) {
    result: creditSubmissionDecision {
      create(input: $input) {
        error
        success
        entity {
          ...CreditSubmissionDecisionFields
        }
      }
    }
  }
`;
